import Entity from '../../entities/entity'

export default class ProductPricing extends Entity<number>{
    pricingProfileId: number;
    pricingTerm:string;
    productId:number;
    price:number;
    pricingTermName: string;
    sku: string;
    productName: string;
    profileDisplayName:string;
    clientCode:string;
    clientName:string;
    creationTime: Date;
    creatorUserName:string;
}